<template>
  <q-btn
    ref="button"
    :label="isEmpty(column.filter) ? column.label : `${column.label}: ${getFilterValues}`"
    :class="[{
      'filter-button': true,
      'selected': !isEmpty(column.filter),
      'highlighted': highlightedButton === column.name
    }]"
    icon-right="keyboard_arrow_down"
    flat
    no-caps
  >
    <q-popover
      anchor="bottom left"
      self="top left"
      @show="highlightButton(column.name); focusInput(column.name);"
      @hide="setFilterValue(); search(column); releaseButton()"
      :offset="popperOffset"
      ref="popover"
    >
      <div class="row items-center">

        <div style="width: 100px;">
          <q-input
            :ref="`input-${column.name}`"
            v-model="inputNumber.from"
            type="number"
            prefix="от&nbsp;"
            hide-underline
          />
        </div>
        <div style="width: 100px;">
          <q-input
            v-model="inputNumber.to"
            type="number"
            prefix="до&nbsp;"
            hide-underline
          />
        </div>
      </div>
      <div style="padding: 10px; border-top: 1px solid #bbb;">
        <q-btn
          @click="setFilterValue(); search(column)"
          color="primary"
          no-caps
          label="Применить"
        />
        <q-btn
          @click="inputNumber = {}"
          flat
          no-caps
          label="Очистить"
        />
      </div>
    </q-popover>
  </q-btn>
</template>

<script>
  import {
    QBtn,
    QPopover,
    QInput,
    QDatetimePicker,
    QCheckbox,
    QSearch,
    QIcon,
    date
  } from 'quasar';

  import TableFilterBase from './TableFilterBase';

  export default {
    name: 'TableFilterInt',
    components: {
      QBtn,
      QPopover,
      QInput,
      QDatetimePicker,
      QCheckbox,
      QSearch,
      QIcon
    },
    extends: TableFilterBase,
    props: {
      column: {
        type: Object,
        default: {}
      },
      columns: {
        type: Array,
        default: []
      }
    },
    methods: {
      setFilterValue () {
        this.column.filter = Object.assign({}, this.inputNumber);
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "./style";
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TableFilter/TableFilterInt.vue